// extracted by css-extract-rspack-plugin
export default {"cls1":"RelatedPapersSidebar-cls1_QG9","cls2":"RelatedPapersSidebar-cls2_lnc RelatedPapersSidebar-cls1_QG9"};